import Email1 from './Email1'
export default Email1
